import { verify } from "@/lib/api/verify";
import { toPositiveNumber } from "@/utils/toPositiveNumber";

export const VERIFY_QUERY_KEY = "smake-use.merchantApi.app.verify";

export const useUserStore = defineStore("userStore", () => {
    const tokenStore = useTokenStore();
    const { token } = storeToRefs(tokenStore);
    const { setToken } = tokenStore;
    const { slug } = storeToRefs(useSlugStore());

    const { data, error } = useQuery({
        enabled: computed(() => !!token.value),
        queryFn: verify,
        queryKey: [VERIFY_QUERY_KEY, slug.value],
        retry: false,
        select: (data) => data.user,
    });

    watchEffect(() => {
        if (!error.value) return;
        setToken();
    });

    // Both come from the backend's environment (SYSTEM_DPI, SYSTEM_LOWEST_DPI),
    // which makes them strings when set there.
    const lowest_dpi = computed(() =>
        toPositiveNumber(data.value?.app.lowest_dpi),
    );
    const dpi = computed(() => toPositiveNumber(data.value?.app.dpi));

    return { data, dpi, lowest_dpi };
});
